function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// eslint-disable-next-line no-unused-vars
var _require = require('./inline-text-builder'),
  InlineTextBuilder = _require.InlineTextBuilder;

// eslint-disable-next-line import/no-unassigned-import
require('./typedefs');
function charactersToCodes(str) {
  return _toConsumableArray(str).map(function (c) {
    return "\\u" + c.charCodeAt(0).toString(16).padStart(4, '0');
  }).join('');
}

/**
 * Helps to handle HTML whitespaces.
 *
 * @class WhitespaceProcessor
 */
var WhitespaceProcessor = /*#__PURE__*/function () {
  /**
   * Creates an instance of WhitespaceProcessor.
   *
   * @param { Options } options    HtmlToText options.
   * @memberof WhitespaceProcessor
   */
  function WhitespaceProcessor(options) {
    _classCallCheck(this, WhitespaceProcessor);
    this.whitespaceChars = options.preserveNewlines ? options.whitespaceCharacters.replace(/\n/g, '') : options.whitespaceCharacters;
    var whitespaceCodes = charactersToCodes(this.whitespaceChars);
    this.leadingWhitespaceRe = new RegExp("^[".concat(whitespaceCodes, "]"));
    this.trailingWhitespaceRe = new RegExp("[".concat(whitespaceCodes, "]$"));
    this.allWhitespaceOrEmptyRe = new RegExp("^[".concat(whitespaceCodes, "]*$"));
    if (options.preserveNewlines) {
      var wordOrNewlineRe = new RegExp("\n|[^\n".concat(whitespaceCodes, "]+"), 'gm');

      /**
       * Shrink whitespaces and wrap text, add to the builder.
       *
       * @param { string }                  text              Input text.
       * @param { InlineTextBuilder }       inlineTextBuilder A builder to receive processed text.
       * @param { (str: string) => string } [ transform ]     A transform to be applied to words.
       */
      this.shrinkWrapAdd = function (text, inlineTextBuilder) {
        var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (str) {
          return str;
        };
        if (!text) {
          return;
        }
        var previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        var anyMatch = false;
        var m = wordOrNewlineRe.exec(text);
        if (m) {
          anyMatch = true;
          if (m[0] === '\n') {
            inlineTextBuilder.startNewLine();
          } else if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]));
          } else {
            inlineTextBuilder.concatWord(transform(m[0]));
          }
          while ((m = wordOrNewlineRe.exec(text)) !== null) {
            if (m[0] === '\n') {
              inlineTextBuilder.startNewLine();
            } else {
              inlineTextBuilder.pushWord(transform(m[0]));
            }
          }
        }
        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
        // No need to stash a space in case last added item was a new line,
        // but that won't affect anything later anyway.
      };
    } else {
      var wordRe = new RegExp("[^".concat(whitespaceCodes, "]+"), 'g');
      this.shrinkWrapAdd = function (text, inlineTextBuilder) {
        var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (str) {
          return str;
        };
        if (!text) {
          return;
        }
        var previouslyStashedSpace = inlineTextBuilder.stashedSpace;
        var anyMatch = false;
        var m = wordRe.exec(text);
        if (m) {
          anyMatch = true;
          if (previouslyStashedSpace || this.testLeadingWhitespace(text)) {
            inlineTextBuilder.pushWord(transform(m[0]));
          } else {
            inlineTextBuilder.concatWord(transform(m[0]));
          }
          while ((m = wordRe.exec(text)) !== null) {
            inlineTextBuilder.pushWord(transform(m[0]));
          }
        }
        inlineTextBuilder.stashedSpace = previouslyStashedSpace && !anyMatch || this.testTrailingWhitespace(text);
      };
    }
  }

  /**
   * Test whether the given text starts with HTML whitespace character.
   *
   * @param   { string }  text  The string to test.
   * @returns { boolean }
   */
  _createClass(WhitespaceProcessor, [{
    key: "testLeadingWhitespace",
    value: function testLeadingWhitespace(text) {
      return this.leadingWhitespaceRe.test(text);
    }

    /**
     * Test whether the given text ends with HTML whitespace character.
     *
     * @param   { string }  text  The string to test.
     * @returns { boolean }
     */
  }, {
    key: "testTrailingWhitespace",
    value: function testTrailingWhitespace(text) {
      return this.trailingWhitespaceRe.test(text);
    }

    /**
     * Test whether the given text contains any non-whitespace characters.
     *
     * @param   { string }  text  The string to test.
     * @returns { boolean }
     */
  }, {
    key: "testContainsWords",
    value: function testContainsWords(text) {
      return !this.allWhitespaceOrEmptyRe.test(text);
    }
  }]);
  return WhitespaceProcessor;
}();
module.exports = {
  WhitespaceProcessor: WhitespaceProcessor
};